import Request from './authorized-request';
import Axios from 'axios';

let cancelToken = null;

export default class AccessoryCategoriesApi {
  static async fetch(options) {
    if (cancelToken) {
      cancelToken.cancel();
      cancelToken = null;
    }

    cancelToken = Axios.CancelToken.source();

    return Request.get('/accessories/categories', {
      params: {
        ...options,
        limit: null,
      },
      cancelToken: cancelToken.token,
    });
  }

  static async fetchOneCategory(id) {
    return Request.get(`/accessories/categories/${id}`);
  }

  static async updateCategory(data) {
    return Request.put(`/c/accessories/categories/${data.id}`, data);
  }

  static async removeCategory(data) {
    return Request.delete(`/c/accessories/categories/${data.id}`);
  }

  static async createCategory(data) {
    return Request.post(`/c/accessories/categories`, data);
  }
}
